module.exports = __webpack_public_path__ + "img/mobile-features-send.3db0ebbd.svg";